<div class="unit-selector-list">
  <h1 [innerHtml]="'unitSelection.title' | cxTranslate"></h1>
  <span class="subtitle" [innerHtml]="'unitSelection.subtitle' | cxTranslate"></span>
  <div class="unit-body">
    <ng-container *ngIf="B2BunitLists$ | async as response">
      <div class="no-result" *ngIf="response.b2bUnits.length == 0; else result">
        {{ 'unitSelection.noResult' | cxTranslate }}
      </div>
      <ng-template #result>
        <div class="lists">
          <div class="list" *ngFor="let list of response.b2bUnits">
            <div *ngIf="list?.active">
              <app-unit-list [list]="list"></app-unit-list>
            </div>
          </div>
        </div>
      </ng-template>
    </ng-container>
  </div>
</div>
